import React, { Fragment, useEffect, useState } from "react"

import PropTypes from "prop-types"

import "./index.less"
import { Button, Input, Modal, Table, Select, Popover, Tooltip } from "antd"
import { CloseCircleOutlined, SearchOutlined } from "@ant-design/icons"
import { map, uniqBy } from "lodash-es"
import questionIcon from "../../images/question.svg"

const { Option } = Select

const AddCollaboratorsClimateSegmentsModal = (props) => {
  const [inputSearch, setInputSearch] = useState("")
  const [selectionType, setSelectionType] = useState("checkbox")
  const [filteredInfo, setFilteredInfo] = useState(null)

  const validateDisable = (record) => {
    if (record.surveys.length === 1) {
      return false
    }
    return !props.employeesAndSurveys.some(
      (elem) => elem.id_employee === record.employee.id_employee
    )
  }

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      props.setStateFrom("employeesSelected", selectedRows)
    },
    getCheckboxProps: (record) => {
      return {
        disabled: validateDisable(record),
        key: record.employee.id_employee,
      }
    },
    selections: [Table.SELECTION_ALL, Table.SELECTION_NONE],
  }

  const footer = () => {
    const disabledButton = props.employeesSelected.length === 0
    let styleButton = {}
    if (disabledButton) {
      styleButton = {
        backgroundColor: "#C4C4C4",
        borderColor: "#C4C4C4",
        color: "#FFF",
      }
    } else {
      styleButton = {
        backgroundColor: "#1890ff",
        borderColor: "#1890ff",
        color: "#FFF",
      }
    }
    return [
      <Button
        key="back"
        className="cancelButton"
        onClick={() =>
          props.setStateFrom("modalAddCollaboratorsClimateSegments", false)
        }>
        Cancelar
      </Button>,
      <Button
        key="submit"
        disabled={disabledButton}
        loading={props.isLoadingAddCollaborators}
        style={styleButton}
        onClick={() => props.addCollaborators()}
        type="primary">
        Agregar
      </Button>,
    ]
  }

  const renderInputSearch = () => {
    return (
      <Input
        placeholder="Buscar..."
        value={inputSearch}
        onChange={(e) => setInputSearch(e.target.value)}
        style={{ width: 200, height: 32 }}
        suffix={
          inputSearch ? (
            <CloseCircleOutlined
              style={{
                cursor: "pointer",
                color: "#FFF",
                backgroundColor: "#979797",
                borderRadius: "50%",
              }}
              onClick={() => setInputSearch("")}
            />
          ) : (
            <SearchOutlined
              style={{
                cursor: "pointer",
                color: "#A7A3A3",
                borderRadius: "50%",
              }}
            />
          )
        }
      />
    )
  }

  const saveSurveyIdForEmployee = (surveyId, employeeId) => {
    let push = true

    const newEmployeesAndSurveys = props.employeesAndSurveys.map((item) => {
      if (item.id_employee === employeeId) {
        item.survey_id = surveyId
        push = false
        return {
          id_employee: employeeId,
          id_survey: surveyId,
        }
      }
      return item
    })

    if (push) {
      newEmployeesAndSurveys.push({
        id_employee: employeeId,
        id_survey: surveyId,
      })
    }

    props.setStateFrom("employeesAndSurveys", newEmployeesAndSurveys)
  }

  const renderTable = () => {
    let filterSegments = []
    props.listPossibleRecipients.map((row) => {
      row.segments.map((segment) => {
        filterSegments.push({
          text: segment.name,
          value: segment.id_segment,
        })
      })
    })
    filterSegments = uniqBy(filterSegments, "value")

    const filteredInfoAux = filteredInfo || {}

    const columns = [
      {
        title: "Nombre",
        dataIndex: "name",
        key: "name",
        sorter: (a, b) =>
          a.employee.full_name.localeCompare(b.employee.full_name),
        render: (text, record) => (
          <span>
            {record.employee.first_name} {record.employee.last_name}
          </span>
        ),
      },
      {
        title: "División",
        width: "114px",
        dataIndex: "name_division",
        key: "name_division",
        render: (text, record) => (
          <span
            style={{
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              width: "102px",
              display: "inline-block",
            }}>
            {record.employee.name_division}
          </span>
        ),
      },
      {
        title: "Segmentos",
        dataIndex: "segments",
        width: "152px",
        filters: filterSegments,
        filteredValue: filteredInfoAux.segments || null,
        onFilter: (value, record) =>
          record.segments.some((elem) => elem.id_segment === value),
        key: "segments",
        render: (text, record) => {
          return (
            <Tooltip
              title={() => {
                let segmentsName = []
                for (let i = 0; i < record.segments.length; i++) {
                  segmentsName.push(
                    <p
                      style={{
                        margin: 0,
                        // maxWidth: "150px",
                        // whiteSpace: "nowrap",
                        // overflow: "hidden",
                        // textOverflow: "ellipsis",
                      }}>
                      {i + 1}. {record.segments[i].name}
                    </p>
                  )
                }
                return <>{segmentsName}</>
              }}>
              <span
                style={{
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  width: "140px",
                  display: "inline-block",
                }}>
                {record.segments.map((segment, index) => {
                  return index === record.segments.length - 1
                    ? segment.name
                    : `${segment.name}, `
                })}
              </span>
            </Tooltip>
          )
        },
      },
      {
        title: () => {
          return (
            <div>
              <span>Cuestionario</span>{" "}
              <Popover
                placement="top"
                content={
                  <div style={{ width: 200 }}>
                    En esta columna, podrás elegir el cuestionario que debe
                    contestar cada colaborador que cuente con más de un
                    cuestionario asignado como consecuencia de los segmentos a
                    los que pertenece.
                  </div>
                }>
                <img src={questionIcon} style={{ marginLeft: 8 }} />
              </Popover>
            </div>
          )
        },
        dataIndex: "survey",
        width: "229px",
        key: "survey",
        render: (text, record) => {
          if (record.surveys.length > 1) {
            return (
              <Select
                value={
                  props.employeesAndSurveys.find(
                    (element) =>
                      element.id_employee === record.employee.id_employee
                  )
                    ? props.employeesAndSurveys.find(
                        (element) =>
                          element.id_employee === record.employee.id_employee
                      ).id_survey
                    : undefined
                }
                placeholder="Seleccionar cuestionario"
                onChange={(e) => {
                  saveSurveyIdForEmployee(e, record.employee.id_employee)
                }}
                style={{ width: "100%" }}>
                {map(record.surveys, (item, index) => {
                  return (
                    <Option key={index} value={item.id_survey}>
                      {item.name}
                    </Option>
                  )
                })}
              </Select>
            )
          }
          return (
            <span
              style={{
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                width: "217px",
                display: "inline-block",
              }}>
              {record.surveys[0].name}
            </span>
          )
        },
      },
    ]

    const onChange = (pagination, filters, sorter, extra) => {
      setFilteredInfo(filters)
    }
    let dataFiltered = props.listPossibleRecipients
    if (inputSearch !== "") {
      dataFiltered = props.listPossibleRecipients.filter((item) => {
        return item.employee.full_name
          .toLowerCase()
          .includes(inputSearch.toLowerCase())
      })
    }

    return (
      <Table
        rowKey={(record) => record.employee.id_employee}
        rowSelection={{
          type: selectionType,
          ...rowSelection,
        }}
        onChange={onChange}
        scroll={{ y: 390 }}
        size="small"
        bordered
        columns={columns}
        dataSource={dataFiltered}
        pagination={{
          defaultPageSize: 10,
          pageSizeOptions: [10, 20, 50, 100],
          showSizeChanger: true,
          size: "default",
        }}
      />
    )
  }
  return (
    <Modal
      width={740}
      className="AddCollaboratorsClimateSegmentsModal"
      style={{ top: 110 }}
      title="Agregar destinatarios"
      closable={false}
      visible={props.modalOpen}
      footer={footer()}>
      <div className="AddCollaboratorsClimateSegmentsModal-Content">
        <div className="AddCollaboratorsClimateSegmentsModal-Content-Header">
          <span>
            Selecciona los destinatarios que deseas agregar a la medición:
          </span>
          {renderInputSearch()}
        </div>
        <div className="AddCollaboratorsClimateSegmentsModal-Content-Table">
          {renderTable()}
        </div>
      </div>
    </Modal>
  )
}

AddCollaboratorsClimateSegmentsModal.propTypes = {
  setStateFrom: PropTypes.func,
  modalOpen: PropTypes.bool,
  listPossibleRecipients: PropTypes.array,
  employeesAndSurveys: PropTypes.array,
  employeesSelected: PropTypes.array,
  addCollaborators: PropTypes.func,
  isLoadingAddCollaborators: PropTypes.bool,
}

export default AddCollaboratorsClimateSegmentsModal
